export const modalHandle = (type) => {
  let element = document.getElementsByClassName('modal')[0];
  let background = window.getComputedStyle(element, null).backgroundColor;

  if (type === undefined) {
    if (background === 'rgba(0, 0, 0, 0.6)') {
      element.classList.remove('modal-open');
    } else {
      element.classList.add('modal-open');
    }
  } else if (type === 'close') {
    element.classList.remove('modal-open');
  } else {
    element.classList.add('modal-open');
  }
}

export const isEmpty = (object) => {
  for (const item in object) {
    if (object.hasOwnProperty(item)) {
      return false;
    }
  }

  return true;
}